const options = {
    key: "noConfig",
    name: "No Config",
};
export default options;
